import { useEffect, useState } from "react";
import { api } from "./api";

export type Fx = { usdBrl: number; source: string; updatedAt: string };
let pending: Promise<Fx | null> | null = null;

/** Cotação do dólar em reais (carregada uma vez por sessão do navegador). */
export function useFx(): Fx | null {
  const [fx, setFx] = useState<Fx | null>(null);
  useEffect(() => {
    pending ??= api.get<Fx>("/fx").catch(() => null);
    void pending.then(setFx);
  }, []);
  return fx;
}

const usdFmt = (v: number) => `US$ ${v.toFixed(v < 1 ? 4 : 2).replace(".", ",")}`;
const brlFmt = (v: number) =>
  v.toLocaleString("pt-BR", {
    style: "currency",
    currency: "BRL",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });

/** "US$ 0,1234 (≈ R$ 0,68)"; sem cotação, apenas o valor em dólar. */
export function money(usd: number, fx: Fx | null): string {
  return fx ? `${usdFmt(usd)} (≈ ${brlFmt(usd * fx.usdBrl)})` : usdFmt(usd);
}
